import CarRangeTable from "../component/car-range/CarRangeTable";

export const RangeCar = () => {
  return (
    <>
      <div>
        <CarRangeTable />
      </div>
    </>
  );
};
